module.exports = __webpack_public_path__ + "static/left_girl-d658dca4370419ec8ff9fd804b0e61e1.png";